'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
class $c_Lpresto_Fetcher$UnifiedError extends $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Exception {
  constructor(uef, request, response) {
    super();
    this.JI = null;
    this.JH = null;
    this.Xp = null;
    this.JI = uef;
    this.JH = request;
    this.Xp = response;
    $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, uef.wM, null, true, true);
  }
  x() {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
  }
  p() {
    return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
  }
  i(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lpresto_Fetcher$UnifiedError)) {
      var x = this.JI;
      var x$2 = x$0.JI;
      if (((x === null) ? (x$2 === null) : x.i(x$2))) {
        var x$3 = this.JH;
        var x$4 = x$0.JH;
        var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_BoxesRunTime$().z(this.Xp, x$0.Xp);
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  r() {
    return 3;
  }
  s() {
    return "UnifiedError";
  }
  j(n) {
    switch (n) {
      case 0: {
        return this.JI;
        break;
      }
      case 1: {
        return this.JH;
        break;
      }
      case 2: {
        return this.Xp;
        break;
      }
      default: {
        throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
      }
    }
  }
}
export { $c_Lpresto_Fetcher$UnifiedError as $c_Lpresto_Fetcher$UnifiedError };
function $isArrayOf_Lpresto_Fetcher$UnifiedError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ik)));
}
export { $isArrayOf_Lpresto_Fetcher$UnifiedError as $isArrayOf_Lpresto_Fetcher$UnifiedError };
var $d_Lpresto_Fetcher$UnifiedError = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Fetcher$UnifiedError, "presto.Fetcher$UnifiedError", ({
  ik: 1,
  L: 1,
  F: 1,
  a: 1,
  b: 1,
  c: 1
}));
export { $d_Lpresto_Fetcher$UnifiedError as $d_Lpresto_Fetcher$UnifiedError };
//# sourceMappingURL=presto.-Fetcher$-Unified-Error.js.map
